<template>
  <q-page id="documents-page" class="stretch-grid position-relative">
    
    <DocumentUpload v-if="$p(['ADMIN', 'MANAGER'], 'or')" :hideEntity="true" :entityItemId="currentManagerId"/>
    <DocumentGrid v-if="$p(['ADMIN']) && currentManagerId" :entityItemId="currentManagerId" :documentTypeId="documentTypeId" :deletable="true" :pagination="pagination" />
    <DocumentGrid v-else-if="$p(['MANAGER', 'RECRUITER', 'AFFILIATE', 'INSTRUCTOR'], 'or') && (managerOptionIds.length > 0)" :entityItemIds="managerOptionIds" :documentTypeId="documentTypeId" :deletable="true" :pagination="pagination" />
    <div class="text-weight-bold" style="position:absolute;left:0;width:100%;top:50%;" v-if="!currentManagerId">
      <p class="text-center text-primary">Admin, Please select a Manager to see their documents.</p>
      <p>
      <q-select
        style="max-width:300px;width:300px;margin:0 auto;"
        float-label="Select Manager"
        :value="currentManagerId"
        :options="managerOptions"
        :before="[{icon: 'fa fa-users'}]"
        @input="val => updateManagerSelectHandler(val)"
        filter autofocus-filter
        v-if="$p(['ADMIN'])"
      />
      </p>
    </div>
    <div id="links" v-if="youtubeLinks.length > 0">
      <h6><q-icon size="22px" color="primary" name="fa fa-youtube-play" /> Video Tutorials</h6>
      <q-list class="scroll-pane">
        <q-item v-for="(yt,i) in youtubeLinks" :key="i" @click.native="openLink(yt)">
          <q-item-side :image="yt.thumb" />
          <q-item-main>
            <q-item-tile label>{{yt.title}}</q-item-tile>
            <q-item-tile label><q-btn style="margin-top:5px" color="grey-3" text-color="grey-9" size="sm">View</q-btn></q-item-tile>
          </q-item-main>
        </q-item>
      </q-list>
    </div>
    <q-layout-footer>
      <q-toolbar>
        <q-toolbar-title>
          <div class="row">
            <div class="col-4">
              <q-select
                float-label="Manager"
                :value="currentManagerId"
                :options="managerOptions"
                :before="[{icon: 'fa fa-users'}]"
                @input="val => updateManagerSelectHandler(val)"
                filter autofocus-filter
                v-if="$p(['ADMIN'])"
              />
            </div>
          </div>
        </q-toolbar-title>
        <q-btn
          label="Upload"
          color="green"
          v-if="currentManagerId "
          @click="openUploadModal()">
        </q-btn>
      </q-toolbar>
    </q-layout-footer> 
  </q-page>
</template>

<script>
import Grid from '../components/Shared/Grid'
import DocumentGrid from '../components/Document/DocumentGrid'
import DocumentUpload from '../components/Document/DocumentUpload'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Documents',
  components: {
    Grid,
    DocumentGrid,
    DocumentUpload
  },
  async mounted () {
    let vm = this
    this.$store.commit('documents/updateUploadForm', {field: 'LK_ENTITY_ID', value: this.entityId})
    await this.$store.dispatch('users/fetchManagers')

    if(this.$p(['MANAGER'])) this.updateCurrentManagerId(this.managerOptionIds[0])
    // setTimeout(function () {
    //   vm.$root.$emit("refreshGrid:documentGrid");
    // }, 0)
  },
  data () {
    return {
      opened: false,
      filterable: true,
      entityId: 11,
      documentTypeId: 25,
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 15,
        page: 1,
        descending: true,
        sortBy: 'CLASS_ID'
      },
      columnOptions: [
        { field: 'DATE_CREATED', name: 'DATE_CREATED', label: 'Upload Date', sortable: true, filterable: true, filter: '', type: 'date' },
        { field: 'DOCUMENT_NAME', name: 'DOCUMENT_NAME', label: 'Document Name', sortable: false, filterable: true, filter: null, type: 'string' },
        { field: 'DOCUMENT_TYPE', name: 'LK_DOCUMENT_TYPE_ID', label: 'Label', sortable: true, filterable: true, filter: null, type: 'string' },
        { field: 'FILE_TYPE', name: 'LK_FILE_TYPE_ID', label: 'Type', sortable: true, filterable: true, filter: null, type: 'string' }
      ],
      youtubeLinks: [
        { 
          title: "Adding A Schedule",
          thumb: "https://img.youtube.com/vi/9e6XtQQJNCM/maxresdefault.jpg",
          link: "https://www.youtube.com/watch?v=9e6XtQQJNCM"
        },
        { 
          title: "Split Classes",
          thumb: "https://img.youtube.com/vi/uBoHhcwMnRc/maxresdefault.jpg",
          link: "https://www.youtube.com/watch?v=uBoHhcwMnRc"
        },
        { 
          title: "Entering Students",
          thumb: "https://img.youtube.com/vi/vDWzmwgBzWo/maxresdefault.jpg",
          link: "https://www.youtube.com/watch?v=vDWzmwgBzWo"
        },
        { 
          title: "Attend A Class",
          thumb: "https://img.youtube.com/vi/m2csCddgkJs/maxresdefault.jpg",
          link: "https://www.youtube.com/watch?v=m2csCddgkJs"
        }
      ]
    }
  },
  computed: {
    ...mapState('documents', {
      loadingData: state => state.loadingData,
      currentManagerId: state => state.currentManagerId
    }),
    ...mapGetters('documents', [
      'documentList'
    ]),
    ...mapGetters({
      managerOptions: "users/managerOptions",
      managerOptionIds: "users/managerOptionIds"
    })
  },
  methods: {
    ...mapActions('documents', [
      'openUploadModal',
      'getPreSignedUrl',
      'fetch',
      'select'
    ]),
    ...mapMutations('documents', [
      'updateCurrentManagerId'
    ]),
    updateManagerSelectHandler (managerId) {
      let vm = this
      if(this.$p(['ADMIN'])) { this.updateCurrentManagerId(managerId) }
      else { this.updateCurrentManagerId(this.managerOptions.map(manager => manager.MANAGER_ID))} 
      setTimeout(function () {
        vm.$root.$emit("refreshGrid:documentGrid");
      }, 0)
    },
    upload () {
    },
    openLink(yt){
      window.open(yt.link,"_blank")
    }
  }
}
</script>

<style lang="stylus">
  #documents-page.stretch-grid
    display flex
    flex-direction column
    > .grid-container
      position static 
      flex 1
      display flex
      .q-table-container
        flex 1
    #links
      height 250px
      width 100%
      background #fbfbfb
      margin-top 20px
      border-radius 3px
      box-shadow 0 2px 2px #777
      h6
        border-bottom: 1px solid #d2d2d2;
        padding: 19px 16px;
        font-size: 15px;
        font-weight: 400;
        color: #717171;
        background #fff
      .q-list
        display: flex;
        overflow-x: auto;
        overflow-y hidden
        height: 175px;
        border: 0;
        .q-item
          min-width 330px
          border-radius: 5px
          background: #fff
          margin: 10px 11px
          border 1px solid #cacaca
          &:hover
            cursor: pointer
            border: 1px solid #4d83ff;
          .q-item-label:first-child
            font-weight 500
            font-size 15px
</style>
